import { MDText } from 'i18n-react';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { EarlyDocumentsCards } from './components/EarlyDocumentsCards';
import LocalTexts from './EarlyDocuments.texts';

import styles from './EarlyDocuments.module.scss';

const LocalT = new MDText(LocalTexts);

export const EarlyDocuments = () => {
	const { details } = useVehicleData();
	return (
		<div className={styles.container}>
			<div>{LocalT.translate('text')}</div>
			<EarlyDocumentsCards showProofOfAddress={Boolean(details?.earlyDocuments?.isProofOfAddressRequired)} />
		</div>
	);
};
